import {useEffect, useState} from "react";
import ApiService from "../../core/service/api-service";
import ResponsiveSelect from "../../core/components/ResponsiveSelect";
import { matchesSearch } from "../../core/utils/text-search";

export default function HospitalSelectBox({onData, ...props}) {
    const [hospitals, setHospitals] = useState([])

    const getHospitals = async () =>
    {
        let response = await ApiService.UserManager.GetHospitalsOfUser();
        if(response.success)
        {
            // Görünen ad: "HASTANE (HL7)@GRUP". Grubu olmayan hastanede eskiden "@undefined" yazıyordu;
            // ek bilgi yoksa ek hiç yazılmaz. Ad TÜRETİLİR, API nesnesinin üzerine yazılmaz: aynı liste
            // ikinci kez çekildiğinde "(HL7)" iki kere ekleniyordu.
            setHospitals(response.data.map(x => {
                const groupName = x?.group?.name;

                return {
                    ...x,
                    name: `${x.name}${x.enableHL7 ? ' (HL7)' : ''}${groupName ? `@${groupName}` : ''}`
                };
            }))
            onData && onData(response.data)
        }

    }

    useEffect(() =>
    {
        getHospitals()
    }, [])

    return (
        <ResponsiveSelect
            mode={'multiple'}
            allowClear
            // antd aramayı yalnız çoklu seçimde kendiliğinden açar; tekli kullanımda (mutabakat
            // ekranı, cihaz/HL7 formları) kapalı geliyordu ve uzun hastane listesi elle taranıyordu.
            showSearch
            options={hospitals}
            // Yerel süzme: liste zaten yüklü, sunucuya gidilmez. Karşılaştırma Türkçe/İngilizce
            // büyük-küçük harf ve aksan duyarsız (bkz. normalizeSearch) — "isk" → "İSKENDERUN".
            filterOption={(input, option) => {
                return matchesSearch(option?.name, input)
            }}
            fieldNames={{
                label: 'name',
                value: 'id'
            }}
            {...props}
        />
    )
}
